import _ from 'underscore';
import {connect} from 'react-redux';
import {withRouter} from '../utils/routerCompat';
import AuctionFilter from '../components/AuctionFilter/AuctionFilter';
import {prepareCategories, setPremiumFilter, prefetchPremiumAuctions} from '../ducks';
import {
    getTransform,
    OBJECT_CATEGORY
} from '../utils/sources';
import {
    getAuctionListFullUrl,
    getPastAuctionListFullUrl
} from '../utils/urls';
import {getFilterParamsFromMatch} from '../utils/auctions';

const _getUrl = past => past
    ? getPastAuctionListFullUrl
    : getAuctionListFullUrl;

export default withRouter(connect(
    (state, {match}) => {
        let transformCategory = getTransform(OBJECT_CATEGORY);
        let {region, category, date} = getFilterParamsFromMatch(match, state.lockCategory);

        return {
            region,
            category,
            date,
            shouldHideRegion: !!state.associationState,
            categoryOptions: _(state.categories.data).map(transformCategory),
            lockCategory: state.lockCategory,
            premiumOnly: state.premiumFilter,
        };
    },
    (dispatch, {history, match, past}) => ({
        onLoad: () => dispatch(prepareCategories()),
        onRegionChange: (lockCategory, region) => {
            let {category, date} = getFilterParamsFromMatch(match, lockCategory);

            history.push(
                _getUrl(past)(1, category, region, date)
            );
        },
        onCategoryChange: (lockCategory, category) => {
            let {region, date} = getFilterParamsFromMatch(match, lockCategory);

            history.push(
                _getUrl(past)(1, category, region, date)
            );
        },
        onDateChange: (lockCategory, date) => {
            let {category, region} = getFilterParamsFromMatch(match, lockCategory);

            history.push(
                _getUrl(past)(1, category, region, date)
            );
        },
        onPremiumChange: (premium) => {
            dispatch(setPremiumFilter(premium));
        },
        onPremiumHover: (lockCategory) => {
            let {page, category, region, date} = getFilterParamsFromMatch(match, lockCategory);
            dispatch(prefetchPremiumAuctions(page, category, region, date, past));
        },
    }),
    (stateProps, dispatchProps, ownProps) => ({
        ...ownProps,
        ...dispatchProps,
        ...stateProps,
        onRegionChange: (region) => dispatchProps.onRegionChange(
            stateProps.lockCategory,
            region
        ),
        onCategoryChange: (category) => dispatchProps.onCategoryChange(
            stateProps.lockCategory,
            category
        ),
        onDateChange: (date) => dispatchProps.onDateChange(
            stateProps.lockCategory,
            date
        ),
        onPremiumHover: () => dispatchProps.onPremiumHover(
            stateProps.lockCategory
        ),
    })
)(AuctionFilter));